<sd-scandata-tree
  [data]="scandata()"
  [currentStation]="currentStation()"
  [cameraProjection]="cameraProjection()!"
  [quotaExceeded]="quotaExceeded()"
  [hasRotatePanoramasFeature]="hasRotatePanoramasFeature()"
  [hasViewInNumarkFeature]="hasViewInNumarkFeature()"
  (modelIconClick)="modelIconClick($event)"
  (modelNameClick)="modelNameClick($event)"
  (modelExpandClick)="toggleExpand($event)"
  (modelDetailClick)="modelDetailClicked($event)"
  (modelFitToViewClick)="modelFitToViewClicked($event)"
  (modelRotatePanoramasClick)="modelRotatePanoramasClicked($event)"
  (stationIconClick)="stationIconClick($event)"
  (stationNameClick)="stationNameClick($event)"
  (viewInNumarkClick)="viewInNumarkClick($event)"
></sd-scandata-tree>
